import { persist } from "easy-peasy";
import AuthStore, { AuthModel } from "store/auth";
import ErrorResponseStore, { ErrorResponseModel } from "store/errorResponse";
import ItemStore, { ItemModel } from "store/item";
import CmsContentStore, { CmsContentModel } from "store/cmsContent";

export interface StoreModel {
  auth: AuthModel;
  item: ItemModel;
  response: ErrorResponseModel;
  cmsContent: CmsContentModel;
}

const Store: StoreModel = {
  auth: AuthStore,
  item: ItemStore,
  response: persist(ErrorResponseStore),
  cmsContent: CmsContentStore,
};

export default Store;
